import { Card, CardContent } from "@ui/card";
import React from "react";
import { ProgressBar } from "./ShadcnProgressBar";
import PlaylistItemMenu from "@components/layouts/b2c/my-corner/PlaylistItemMenu";
import { Menu } from "lucide-react";

interface PlaylistItemCardProps {
  id: string;
  image: string;
  title: string;
  author: string;
  progress: number;
  draggedItemId?: string | null;
  isDraggMode?: boolean;
  draggable?: boolean;
  onClick?: () => void;
  onDragStart?: (e: React.DragEvent<HTMLDivElement>, id: string) => void;
  onDragOver?: (e: React.DragEvent<HTMLDivElement>, id: string) => void;
  onDragEnd?: () => void;
  isLocked?: boolean | undefined;
}

const PlaylistItemCard = ({
  id,
  image,
  title,
  author,
  progress,
  draggedItemId,
  isDraggMode,
  draggable = true,
  onClick,
  onDragStart,
  onDragOver,
  onDragEnd,
  isLocked,
}: PlaylistItemCardProps) => {
  return (
    <Card
      className={`w-full cursor-pointer p-3 hover:shadow-md dark:border-[#4F5056] dark:bg-[#37383F] ${
        draggedItemId === id &&
        "border-2 border-primary dark:border-2 dark:border-primary"
      } ${isDraggMode && "cursor-grab"}`}
      draggable={draggable}
      onClick={onClick}
      onDragStart={(e) => onDragStart && onDragStart(e, id)}
      onDragOver={(e) => onDragOver && onDragOver(e, id)}
      onDragEnd={onDragEnd}
    >
      <CardContent className="flex items-center justify-start gap-5 p-0">
        <div className="relative h-[70px] w-[74px] overflow-hidden rounded-md">
          <img src={image} alt="No item" className="h-full w-full" />
          {isLocked ? (
            <div className="absolute bottom-[6px] left-[6px] flex h-[25px] w-[25px] items-center justify-center rounded-full bg-[linear-gradient(180deg,_rgba(255,_204,_101,_0.90)_0%,_rgba(255,_191,_62,_0.95)_100%)] p-1">
              <img
                src="/assets/icons/premium.svg"
                alt="premium"
                className="h-full w-full"
              />
            </div>
          ) : null}
        </div>
        <div className="flex w-full flex-col items-start justify-center">
          <div className="flex w-full items-center justify-between">
            <div className="flex w-full flex-col items-start justify-center">
              <div className="text-[16px] font-medium dark:text-white">
                {title}
              </div>
              <div className="text-[14px] text-[#999999]">{author}</div>
            </div>
            <PlaylistItemMenu itemId={id} />

            {isDraggMode && <Menu className="dark:text-white" />}
          </div>
          <div className="flex w-full items-center justify-center gap-3">
            <ProgressBar value={progress * 100} height="h-1" />
            <div className="text-[#B5B5B5]">{(progress * 100).toFixed()}%</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PlaylistItemCard;
